
import { Options, Vue } from 'vue-class-component'
import Header from '@/components/Header.vue' // @ is an alias to /src
import Nav from '@/components/Nav.vue' // @ is an alias to /src
import Login from '@/components/Login.vue'
import Logout from '@/components/Logout.vue'
import CustomerContracts from '@/components/contract/customer.vue'
import { mapActions } from 'vuex'
@Options({
  components: {
    Header,
    Nav,
    Login,
    Logout,
    CustomerContracts
  },
  data () {
    return {
      loading: true
    }
  },
  async created () {
    await this.set_theme()
    await this.handleCheckUser()
  },
  methods: {
    ...mapActions(['set_user', 'set_theme']),
    async handleCheckUser () {
      try {
        this.loading = true
        const token = localStorage.getItem('token')
        if (token) {
          const user = (await this.axios.get('auth')).data
          this.set_user(user)
        }
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    }
  }
})
export default class App extends Vue {}
